module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-3.5cbe6c0a.png";